module.exports = __webpack_public_path__ + "img/packages_02.d355a0c2.jpg";